import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEvent,
  HttpRequest,
  HttpResponse,
  HttpEventType,
} from "@angular/common/http";
import { environment } from "apps/epims/mrsoftepims/src/environments/environment";
import { LandTitleRegisterDto } from '@cradua/data';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DocumentService {
  url = environment.apiUrl;

  constructor(private http: HttpClient) {}

  public uploadFile(
    file: File,
    data: any,
    type: string,
  ): Observable<HttpEvent<{}>> {
    const formData = new FormData();
    if( typeof file !== 'string' && file) {
      // console.log("Reaching Service for Upload doc", file);
      formData.append("Document", file, file.name);
    }
    formData.append("Body", JSON.stringify(data));
    let selectedUrl;
    if(data.type === 'landTitleRegister') {
       selectedUrl = 'acquisition-management/document-upload';
    }

    const options = {
      reportProgress: true,
    };

    const req = new HttpRequest(
      "POST",
      `${this.url + selectedUrl}`,
      formData,
      options,
    );

    // console.log("Http Request ", req);
    return this.http.request(req);
  }

  public uploadSingleFile(
    files: Set<File>,
    data: any[],
    type: string,
  ): Observable<HttpEvent<{}>> {
    // this will be the our resulting map
    // const status: { [key: string]: { progress: Observable<number> } } = {};

    files.forEach((file) => {
      // create a new multipart-form for every file
      const formData: FormData = new FormData();
      formData.append("file", file, file.name);

      // create a http-post request and pass the form
      // tell it to report the upload progress
      const req = new HttpRequest(
        "POST",
        `${this.url + "student/upload-cover-photo"}`,
        formData,
        {
          reportProgress: true,
        },
      );

      return this.http.request(req);
    });
    return null;
    // return the map of progress.observables
  }

  fetchAcquisitionDocument(id: string): Observable<LandTitleRegisterDto[]> {
    return this.http.post<LandTitleRegisterDto[]>(this.url + "acquisition-management/landTitleRegister/", {id});
  }

  createAcquisitionDocument(data: LandTitleRegisterDto[]): Observable<LandTitleRegisterDto[]> {
    return this.http.post<LandTitleRegisterDto[]>(this.url + "acquisition-management/document", data);
  }
}
